// extracted by mini-css-extract-plugin
export default {"text":"Sseventh_text__ywX2s","title":"Sseventh_title__sU4yX","desc":"Sseventh_desc__uv2Zm","desc_2":"Sseventh_desc_2__ZRCMh","Sseventh":"Sseventh_Sseventh__7BV62"};